import React from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import Review from './Review';

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-10%',
    [theme.breakpoints.between('xs', 'md')]: {
      left: '-8%',
    },
    [theme.breakpoints.down('sm')]: {
      left: '-2%',
    },
  },
}));

const ApplicationReview = ({
  routeSteps,
  amendment,
}: {
  routeSteps: { label: string }[];
  amendment: boolean;
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <TitleHeader
        title={t(
          'specialConsideration->>ApplyForSpecialConsideration.ApplyForSpecialConsideration'
        )}
      />
      <HeaderTemplate>
        <Stepper className={classes.stepper} activeStep={2} steps={routeSteps} />
      </HeaderTemplate>
      <Review amendment={amendment} />
    </>
  );
};

export default ApplicationReview;
